import { useIntl } from "react-intl";
import BodyList from "../../BodyList";
import HeaderList from "../../HeaderList";
import dayjs from "dayjs";
import { Spin } from "antd";
import Empty from "../../../common/Empty";

const SalesHistory = ({ data, setPage, page, isLoading }: any) => {
  const intl = useIntl();

  const cols = [
    intl.formatMessage({
      id: "number",
      defaultMessage: "#",
    }),

    intl.formatMessage({
      id: "operationDate",
      defaultMessage: "Operation Date",
    }),

    intl.formatMessage({
      id: "operationStatus",
      defaultMessage: "Operation Status",
    }),

    intl.formatMessage({
      id: "branch",
      defaultMessage: "Branch",
    }),

    intl.formatMessage({
      id: "client",
      defaultMessage: "Client",
    }),

    intl.formatMessage({
      id: "channel",
      defaultMessage: "Channel",
    }),

    intl.formatMessage({
      id: "sold",
      defaultMessage: "Sold",
    }),

    intl.formatMessage({
      id: "total",
      defaultMessage: "Total",
    }),

    intl.formatMessage({
      id: "giftCard",
      defaultMessage: "Gift Card",
    }),

    intl.formatMessage({
      id: "serviceTax",
      defaultMessage: "Service Tax",
    }),

    intl.formatMessage({
      id: "amountDue",
      defaultMessage: "Amount Due",
    }),
  ];
  const FormattedList = (data: any[]) => {
    return data?.map((x: any) => {
      return {
        id: x?.id,
        date: dayjs(x?.created_at).format("DD-MM-YYYY HH:mm"),
        status: x?.status,
        location: x?.location?.name,
        client_name:
          x?.client_profile?.first_name + x?.client_profile?.last_name,
        channel: null,
        sold: null,
        subtotal: x?.subtotal,
        giftcard: null,
        taxes: x?.taxes,
        pay: x?.pay,
      };
    });
  };
  console.log(data?.data);

  console.log(FormattedList(data?.data));
  return isLoading ? (
    <Spin className="flex items-center justify-center my-4" />
  ) : data?.data?.length ? (
    <div className="overflow-auto">
      <HeaderList cols={cols} />
      <BodyList
        data={FormattedList(data?.data)}
        page={page}
        setPage={setPage}
        isLoading={isLoading}
      />
    </div>
  ) : (
    <Empty title="لا توجد مبيعات" subTitle="" />
  );
};

export default SalesHistory;
